export enum ServiceNowAdapterEvent {
    RINGCX_FRAME_LOAD = 'ringcx-frame-load',
    HEADER_ICON_CLICKED = 'openframe_header_icon_clicked',
    ICON_CLICKED = 'openframe_icon_clicked',
    TITLE_ICON_CLICKED = 'openframe_title_icon_clicked',
    OPENFRAME_SHOWN = 'openframe_shown',
    OPENFRAME_HIDDEN = 'openframe_hidden',
    OPENFRAME_BEFORE_DESTROY = 'openframe_before_destroy',
    COMMUNICATION_EVENT = 'openframe_communication',
    COMMUNICATION_FAILURE = 'openframe_communication_failure',
    EXPAND = 'openframe_expand',
    COLLAPSE = 'openframe_collapse',
    OPENFRAME_AWA_AGENT_PRESENCE = 'openframe_awa_agent_presence',
    OPENFRAME_AWA_INTERACTION_EVENT_ACCEPTED = 'openframe_awa_workitem_accepted',
    OPENFRAME_AWA_INTERACTION_EVENT_REJECTED = 'openframe_awa_workitem_rejected',
    OPENFRAME_AWA_INTERACTION_EVENT_OFFERED = 'openframe_awa_workitem_offered',
    OPENFRAME_AGENT_OFF_INTERACTION = 'openframe_agent_off_interaction',
    CLICK_TO_DIAL = 'click-to-dial',
    HIDE_RCX_IFRAME = 'hide_rcx_iframe',
    UPDATE_IS_LOADING = 'update_is_loading',
    UPDATE_IS_ERROR = 'update_is_error',
    UPDATE_SECOND_IFRAME_STATUS = 'update_second_iframe_status',
    RESET_SECOND_IFRAME = 'reset_second_iframe',
}
